// extracted by mini-css-extract-plugin
export default {"header":"CreateProject_header__I3URX","header-title":"CreateProject_header-title__Avbvd","project-box":"CreateProject_project-box__gdMPO"};